import React from 'react'
import './LHSNavigation.css'
import { readCookie, checkUserLogin, isInDomain, isInFlyinDomain } from 'AccountsUtils'
import { getMappedValue } from '../../../utils/arabicUtils'
import { getWalletUrl } from '../../../utils/walletUtils'

const LHSNavigation = props => {
  const isLogin = checkUserLogin()
  const ctAuthNoLogin = readCookie('ct-auth-no-login')
  const isOtpFlow = ctAuthNoLogin && !isLogin
  const selectedClass = isOtpFlow ? '' : 'selected'
  const { section, abDesktopData = {} } = props

  // converted nested ternary operator to this function,
  // it will select trips tab as default if page is not in this repo
  const selectTripsTab = () => {
    if (section === 'hifive' ||
      section === 'express_tab' ||
      section === 'wallet_tab' ||
      section === 'profile_tab') {
      return false
    }
    return true
  }

  let navigationOptions = [
    {
      liClass: `tripsTab ${selectTripsTab() ? selectedClass : ''}`,
      link: isInFlyinDomain() ? '/accounts/trips?chnl=Fly' : '/accounts/trips',
      linkClass: 'app-link icon navLink navTrips',
      id: 'trips_tab',
      title: 'Your travel bookings',
      text: 'Trips',
      enable: true
    },
    {
      liClass: 'travellersTab',
      link: '/account/travellers',
      linkClass: 'app-link icon navLink navTravellers',
      id: 'travellers_tab',
      title: 'People you book travel for',
      text: 'Travellers',
      enable: true
    },
    {
      liClass: `walletTab separator ${section === 'wallet_tab' ? selectedClass : ''}`,
      link: getWalletUrl(),
      linkClass: 'app-link icon navLink navWallet',
      id: 'wallet_tab',
      title: isInDomain() ? 'Cleartrip Wallet' : 'Your Wallet',
      text: isInDomain() ? 'Cleartrip Wallet' : 'Wallet',
      enable: true
    },
    {
      liClass: `hifiveTab ${section === 'hifive' ? selectedClass : ''}`,
      link: '/accounts/hi-five',
      linkClass: 'app-link icon navLink navTrips hifiveNav',
      id: 'hifive_tab',
      title: 'Hi Five',
      text: 'Hi-Five',
      enable: isInDomain() && abDesktopData.hi_five === 'b'
    },
    {
      liClass: `expresswayTab separator ${section === 'express_tab' ? selectedClass : ''}`,
      link: '/accounts/expressway',
      linkClass: 'app-link icon navLink navExpress',
      id: 'express_tab',
      title: 'Your settings for 1-click travel bookings',
      text: 'Expressway',
      enable: true
    },
    {
      liClass: `profileTab separator ${section === 'profile_tab' ? selectedClass : ''}`,
      link: isInDomain() ? '/accounts/profile' : '/account/profile',
      linkClass: 'app-link icon navLink navMe',
      id: 'profile_tab',
      title: 'Your profile &amp; preferences',
      text: 'Profile',
      enable: true
    },
    {
      liClass: 'settingsTab',
      link: '/account/settings',
      linkClass: 'app-link icon navLink navSettings',
      id: 'settings_tab',
      title: 'Your site settings',
      text: 'Settings',
      enable: true
    }
  ]

  if (isInFlyinDomain()) {
    navigationOptions = navigationOptions.filter(option => option.id === 'trips_tab' || option.id === 'wallet_tab'
    )
  }

  return (
    <ul className="navLeft">
      {navigationOptions.map((option, index) => {
        const { liClass, link, linkClass, id, title, text, enable } = option
        const lockClass = isOtpFlow ? 'navLinkLock' : ''
        if (enable) {
          return (
            <li key={id + index} className={`${liClass} navTab`}>
              <a
                href={link}
                onClick={e => {
                  if (isOtpFlow) {
                    e.preventDefault()
                  }
                }}
                className={`${linkClass} ${lockClass} cursorPoi us-text`}
                id={id}
                title={title}
              >
                {getMappedValue(text)}
              </a>
            </li>
          )
        }
        return null
      })}
    </ul>
  )
}

export default LHSNavigation
